//--------------------------------\\
//--- Validation de formulaire ---\\
//--------------------------------\\

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Dans ce fichier, on retrouve toutes les validations de formulaire, les messages d'erreur et le formatage.
// Pour que tout fonctionne, il faut les node-modules formatter et jquery-validation déjà.
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Importation ----------------------------------------------------------------------------------------------------
import $ from 'jquery'
//-----------------------------------------------------------------------------------------------------------------


// LES FONCTIONS
// Fonction qui gère le label des input
export function fixInput() {
  $('input').each(function() {
    ($(this).val() != '' ? $(this).addClass('notEmpty') : $(this).removeClass('notEmpty'))
  })

  // Si le focus est sur le champ, on enlève la classe vide pour que le label se déplace
  $('input').focusin(function() {
    $(this).removeClass('notEmpty')
  })

  // Si le champ est vide, on replace le label à sa position d'origine au focusout
  $('input').focusout(function() {
    ($(this).val() != '' ? $(this).addClass('notEmpty') : $(this).removeClass('notEmpty'))
  })
}

// Transforme les selects
export function magicSelect() {
  $('.chosen-select').chosen({ disable_search: true })
}



// LES MESSAGES
// Fonction contenant tous les messages
export function getMessages() {
  return {
    required: 'Ce champ est obligatoire.',
    select: 'Veuillez sélectionner une option.',
    email: 'Veuillez fournir une adresse électronique valide.',
    phone: 'Veuillez fournir un numéro de téléphone valide.',
    postale: 'Veuillez fournir un code postal valide.',
    date: 'Veuillez fournir une date valide.',
    accept: 'Le fichier doit être un document pdf, docx, doc ou rtf.',
    file: 'Veuillez lier le fichier adéquat pour ce champ.'
  }
}



// LES RÈGLES __________
// Règle du email
export function validationEmail() {
  jQuery.validator.addMethod('courriel', function(value, element) {
    return this.optional(element) || /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/.test(value)
  })
}

// Règle du poids maximal d'un fichier
function validationFilesize() {
  $.validator.addMethod('filesize', function(value, element, param) {
    return this.optional(element) || (element.files[0].size <= param)
  }, 'La taille maximale du fichier doit être 1MB')
}



// LES FORMATS __________
// Format du téléphone
export function formatPhone(element) {
  $(element).mask('(000) 000-0000')
}

// Format du code postal
export function formatCodePostal(element) {
  $(element).mask('ABA BAB', {'translation': {
    A: {pattern: /[A-Za-z]/},
    B: {pattern: /[0-9]/}
  }})
}

// Format de la date
export function formatDate(element) {
  $(element).mask('00/00/00')
}



// LES VALIDATIONS __________
// Fonction exécutant la validation de chaque formulaire
export function formValidation(form, submit, rules, messages, handler) {
  $.validator.setDefaults({
    ignore: []
  })
  $(form).validate({
    debug: false,
    rules: rules,
    messages: messages,
    errorElement: 'div',
    errorPlacement: function(error, element) {
      var placement = $(element).data('error')
      if (element.attr('type') == 'radio') {
        error.insertBefore(element.closest('.radiobox-field').find('.errorblock'))
      } else if (element.attr('type') == 'checkbox') {
        error.insertBefore(element.closest('.checkbox-field').find('.errorblock'))
      } else if (placement) {
        $(placement).append(error)
      } else {
        error.insertBefore(element)
      }
    },
    submitHandler: function() {
      if (typeof handler != 'undefined') {
        handler()
        return false
      }
      return true
    }
  })
  $(submit).click(function() {
    $(form).submit()
  })
}


// Validation du formulaire de contact
export function formContact() {
  validationEmail()
  formatPhone('#contactTelephone')
  var m = getMessages()
  var rules = {
    nom:       { required: true },
    prenom:    { required: true },
    courriel:  { required: true, courriel: true },
    telephone: { required: true, minlength: 14  },
    message:   { required: true }
  }
  var messages = {
    prenom:    { required: m.required },
    nom:       { required: m.required },
    courriel:  { required: m.required, courriel: m.email  },
    telephone: { required: m.required, minlength: m.phone },
    message:   { required: m.required }
  }

  formValidation('#formContact', '#submitContact', rules, messages)
}


// Validation du formulaire de l'infolettre
export function formInfolettre() {
  validationEmail()
  var m = getMessages()
  var rules = {
    courriel:  { required: true, courriel: true },
  }
  var messages = {
    courriel:  { required: m.required, courriel: m.email  },
  }
  formValidation('#formNewsletter', '.submitnewsletter', rules, messages)
}


// Validation du formulaire de contact
export function formSearch(formID,formSubmit) {
  var m = getMessages()
  var rules = {
    q: { required: true },
  }
  var messages = {
    q: { required: m.required },
  }

  formValidation(formID, formSubmit, rules, messages)
}


// Validation du formulaire d'emploi
export function formJob() {
  validationEmail()
  validationFilesize()
  formatPhone('#contactTelephone')
  var m = getMessages()
  var validTypeList = [ 'application/pdf' ]
  var validTypes = validTypeList.join(',')
  var rules = {
    nom:       { required: true },
    prenom:    { required: true },
    courriel:  { required: true, courriel: true },
    telephone: { required: true, minlength: 14  },
    cv:        { required: true, accept: validTypes, filesize: 1048576 },
    letter:    { required: true, accept: validTypes, filesize: 1048576 }
  }
  var messages = {
    prenom:    { required: m.required },
    nom:       { required: m.required },
    courriel:  { required: m.required, courriel: m.email  },
    telephone: { required: m.required, minlength: m.phone },
    cv:        { required: m.file, accept: m.accept },
    letter:    { required: m.file, accept: m.accept }
  }
  formValidation('#formJob', '#submitJob', rules, messages)
}

export function changeLabelUpload() {
  $('input[type=file]').change(function() {
    $(this).next('label').find('span').text($(this).val().split(/(\\|\/)/g).pop())
  })
}

// Handle le formulaire de payment
function handleContact() {
  $.request('courrielator::onFormSubmit', {
    loading: $.oc.stripeLoadIndicator,
    data: {
      nom:       $('#contactNom').val(),
      prenom:    $('#contactPrenom').val(),
      courriel:  $('#contactCourriel').val(),
      telephone: $('#contactTelephone').val(),
      message:   $('#contactMessage').val()
    },
    complete: function (output) {
      var response = output.responseJSON
    }
  })
}
